import React from 'react';

/**
 * Badge de estado de envío de email (variante de la vista de resultado de CAUForm).
 * Muestra un indicador visual verde si el email se envió/encoló correctamente.
 */
export function StatusBadge({ label, status }) {
  const ok = status === 'sent' || status === 'queued';
  return (
    <div
      data-testid={`status-badge-${label?.toLowerCase?.() || 'unknown'}`}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        background: ok ? '#f0faf3' : '#fff3cd',
        border: `1px solid ${ok ? '#cfe3d6' : '#fde68a'}`,
        borderRadius: '20px',
        padding: '6px 14px',
        fontSize: '13px',
        color: ok ? '#1a5c2e' : '#92400e',
        fontWeight: 500
      }}
    >
      {ok ? '✅' : '⚠️'} {label}: <strong>{status}</strong>
    </div>
  );
}

export default StatusBadge;
